(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('systemConstants', {
            'IMMO_HUB_ID': 33,
            'AMBASSADOR_PROFILE_ID': 7,
            'NOT_RECONCILED_ORDER_STATUS': 'NOT_RECONCILED',
            SYSTEM_IMAGES_BASE_URL: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/',
            CHRONO_UNIT: {
                MINUTES: 'MINUTES',
                HOURS: 'HOURS',
                DAYS: 'DAYS'
            },
            BOOTSTRAP_RESOLUTIONS: {
                MIN_XS: 0,
                MAX_XS: 767,
                MIN_SM: 768,
                MAX_SM: 991,
                MIN_MD: 992,
                MAX_MD: 1199,
                MIN_LG: 1200
            },
            IMAGE_RESOLUTIONS: {
                LIST_CARD: '400x400',
                GALLERY_CARD: '400x400',
                DETAIL_PICTURE: '400x400',
                SINGLE_PRODUCT: '400x400',
                DETAILS_COVER: 'original',
                DETAILS_GALLERY: '100x100'
            },
            'STORE_ADMIN_ACCOUNT': 'Store Admin Account ',
            UI_SORTABLE_OPTIONS: {
                helper: 'clone',
                appendTo: 'body',
                zIndex: 10000,
                tolerance: 'pointer',
                scroll: true,
                scrollSensitivity: 100,
                scrollSpeed: 30,
                forceHelperSize: true,
                forcePlaceholderSize: true,
                create: function () {
                    var sortableEl = this;
                    var $sortable = angular.element(sortableEl);
                    var selector = '.ui-sortable-handle';
                    var shouldDisableCursorAtOnCreate = !!$sortable.sortable('option', 'disableCenterOnPointer');

                    function applyCursorAtForElement(el) {
                        var $firstItem = angular.element(el);
                        $sortable.sortable('option', 'cursorAt', {
                            left: Math.round($firstItem.outerWidth() / 2),
                            top: Math.round($firstItem.outerHeight() / 2)
                        });
                    }

                    if (!shouldDisableCursorAtOnCreate) {
                        var existingLi = sortableEl.querySelector(selector);
                        if (existingLi) {
                            applyCursorAtForElement(existingLi);
                        } else {
                            waitForElement(selector, sortableEl).then(function (el) {
                                applyCursorAtForElement(el);
                            });
                        }
                    }
                },
                start: function (event, ui) {
                    var itemHeight = ui.item.outerHeight();
                    var itemWidth = ui.item.outerWidth();
                    var centerLeft = Math.round(itemWidth / 2);
                    var centerTop = Math.round(itemHeight / 2);

                    angular.element(this).sortable('option', 'cursorAt', {
                        left: centerLeft,
                        top: centerTop
                    });

                    ui.placeholder.height(itemHeight);
                    ui.placeholder.width(itemWidth);

                    ui.helper.css({
                        width: itemWidth + 'px',
                        height: itemHeight + 'px',
                        boxSizing: 'border-box'
                    });
                }
            }
        });
})();
